import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { UserDto } from '@interfaces/UserDto';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'pop-user-picker',
  templateUrl: './user-picker.component.html',
  styleUrls: ['./user-picker.component.less']
})
export class UserPickerComponent extends BaseComponent {
  public users: UserDto[] = [];
  public usersFiltered: UserDto[] = [];

  public queryText = '';

  private _selectedUser: UserDto | undefined;
  @Input() get selectedUser() {
    return this._selectedUser;
  }
  set selectedUser(value: UserDto | undefined) {
    this._selectedUser = value;
    this.selectedUsersChange.emit(value);
  }

  @Output() selectedUsersChange = new EventEmitter<UserDto | undefined>();

  public constructor(private userService: UserService) {
    super();
  }

  public async ngOnInit() {
    const users = await this.userService.getUsers();

    this.usersFiltered = this.users = users;
  }

  public filterUsers(event: { query: string }) {
    this.usersFiltered = this.users?.filter(u => this.matchesQuery(u, event.query)) ?? [];
  }

  private matchesQuery(user: UserDto, queryRaw: string): unknown {
    const query = queryRaw.toLocaleLowerCase();
    const email = user.email?.toLocaleLowerCase();
    if (email.includes(query)) {
      return true;
    }
    const name = user.name?.toLocaleLowerCase();

    if (name.includes(query)) {
      return true;
    }
    return false;
  }

  public add() {
    if (this.usersFiltered.length >= 0) {
      this.selectedUser = this.usersFiltered[0];
    } else {
      this.selectedUser = undefined;
    }
    this.queryText = '';
  }
}
